<img src="assets/icons/svet-icon.svg" alt="">
<ul>
    <h4>{{ 'about.title' | translate }}</h4>
    <li><a routerLink="/privacy">{{ 'policy.title' | translate }}</a></li>
    <li><a routerLink="/terms">{{ 'terms.title' | translate }}</a></li>
</ul>

<ul>
    <h4>{{ 'footer.social_networks.title' | translate |autoCapitalize}}</h4>

    @for (social of socials; track $index) {
    <li>
        <a [href]="social.url">
            <img height="24" width="24" [src]="social.icon" [alt]="'svet' + social.name" />
            {{ 'socials.' + social.name.toLowerCase() | translate | titlecase}}</a>
    </li>
    }
</ul>